import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["onChange", "label", "children", "value"];
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import { Checkbox } from 'antd';
import React from 'react';
import PropTypes from 'prop-types';
import _noop from 'lodash/noop';
import './checkbox.module.scss';
var CheckBoxWrapper = function CheckBoxWrapper(_ref) {
  var onChange = _ref.onChange,
    label = _ref.label,
    children = _ref.children,
    value = _ref.value,
    restProps = _objectWithoutProperties(_ref, _excluded);
  var rest = _objectSpread({
    checked: value
  }, restProps);
  return /*#__PURE__*/React.createElement(Checkbox, _extends({}, rest, {
    onChange: onChange
  }), label || children);
};
CheckBoxWrapper.propTypes = _objectSpread(_objectSpread({}, Checkbox.propTypes), {}, {
  onChange: PropTypes.func,
  label: PropTypes.string
});
CheckBoxWrapper.defaultProps = _objectSpread(_objectSpread({}, Checkbox.defaultProps), {}, {
  onChange: _noop,
  label: ''
});
export default CheckBoxWrapper;